export const nonPhysicalProductDeliveryText = 'Delivered via email within 2 hours'
export const giftingTooltipText =
  'The recipient will receive an email with your gift message when the order ships. Information on easy returns will be included in their delivery confirmation email. Gift cards are sent via email within 2 hours.'
